/**
 * Header hide on scroll down, show on scroll up.
 * Adds .site-header--hidden when user scrolls down; removes it when scrolling up or at top.
 */
export function headerScroll() {
	const header = document.querySelector('.site-header');
	if (!header) return;

	const scrollThreshold = 80;
	const minScrollDelta = 10;
	let lastScrollY = window.scrollY ?? 0;
	let ticking = false;

	function updateHeader() {
		const scrollY = window.scrollY ?? 0;
		const delta = scrollY - lastScrollY;

		if (scrollY <= scrollThreshold) {
			header.classList.remove('site-header--hidden');
		} else if (delta > minScrollDelta) {
			header.classList.add('site-header--hidden');
		} else if (delta < -minScrollDelta) {
			header.classList.remove('site-header--hidden');
		}

		lastScrollY = scrollY;
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(updateHeader);
			ticking = true;
		}
	}

	window.addEventListener('scroll', onScroll, { passive: true });
}